import React from 'react';
import StylishNewSelect from 'components/DesignSystems/New/StylishNewSelect';

type AgentMode = 'ask' | 'agent_auto' | 'agent_confirm';

type ModeOption = {
  value: AgentMode;
  label: string;
  /** Compact label shown in the collapsed control to save sidebar real estate. */
  shortLabel: string;
  disabled: boolean;
};

const MODE_OPTIONS: ModeOption[] = [
  { value: 'ask', label: 'Ask', shortLabel: 'Ask', disabled: false },
  {
    value: 'agent_confirm',
    label: 'Ask Before Edits',
    shortLabel: 'Edit',
    disabled: false,
  },
  // Auto Edit is parked while we focus on Ask Before Edits.
  {
    value: 'agent_auto',
    label: 'Auto Edit (Coming Soon)',
    shortLabel: 'Auto',
    disabled: true,
  },
];

interface AgentModeSelectorProps {
  selectedMode: AgentMode;
  onModeChange: (mode: AgentMode) => void;
  disabled?: boolean;
  className?: string;
}

const AgentModeSelector: React.FC<AgentModeSelectorProps> = ({
  selectedMode,
  onModeChange,
  disabled,
  className = '',
}) => {
  const selectedOption = MODE_OPTIONS.find((opt) => opt.value === selectedMode);

  return (
    <StylishNewSelect
      classes={`agent-mode-selector-compact ${className}`}
      options={MODE_OPTIONS}
      value={selectedOption}
      onChange={(option) => onModeChange(option.value)}
      isDisabled={disabled}
      isSearchable={false}
      isClearable={false}
      isOptionDisabled={(opt: unknown) => (opt as ModeOption).disabled}
      formatOptionLabel={(opt: unknown, meta: { context: string }) =>
        meta.context === 'value'
          ? (opt as ModeOption).shortLabel
          : (opt as ModeOption).label
      }
      menuPlacement="top"
      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
      styles={{
        menuPortal: (base: Record<string, unknown>) => ({
          ...base,
          zIndex: 9999,
        }),
      }}
    />
  );
};

export default AgentModeSelector;
